import { Route } from "@angular/router";

export const soldProductsRoutes: Route[] = [
  {
    path: "",
    title: "PRODUCTS.TITLE",
    loadComponent: () => import("./pages/sold-products/sold-products.component").then((m) => m.SoldProductsComponent),
  },
];
